import { cn } from "../utils/cn.js";
import type { Mood } from "../moods.js";

export interface MoodChipProps {
  mood: Mood;
  className?: string;
}

/**
 * MoodChip — tiny 8px color dot, inline.
 *
 * Used inside pills, list items, and chat metadata to convey mood at
 * a glance without taking up space.
 */
export const MoodChip = ({ mood, className }: MoodChipProps) => (
  <span
    aria-label={mood.name}
    className={cn("inline-block h-2 w-2 shrink-0 rounded-pill", mood.bg, className)}
  />
);
